import { Base } from './base';
import { IValidatorMethod, IValidatorMessage } from '../types';

/**
 * Use to create a Customized validator
 * @param {function} method - validate function will be called to validate value
 * @param {function|string} message - a function or string, message of this validator
 * @param {boolean} blockInput - whether block input when validate failed
 * @param {I18nModel} i18n - i18n to get message, only used for Base class
 */
class Custom extends Base {
  blockInput: boolean;

  message: IValidatorMessage;

  isValid: IValidatorMethod;

  constructor(method: IValidatorMethod, message: IValidatorMessage, blockInput: boolean, i18n: I18nModel) {
    super(i18n);

    if (blockInput) {
      this.blockInput = blockInput;
    }

    if (message) {
      this.message = message;
    }

    this.isValid = method;
  }
}

/**
 * Create customize validator instance
 * @param {function} method - validate function will be called to validate value
 * @param {function|string} message - a function or string, message of this validator
 * @param {boolean} blockInput - whether block input when validate failed
 * @param {I18nModel} i18n - i18n to get message, only used for Base class
 * @returns {Custom} - customized validator instance
 */
export function custom(method: IValidatorMethod, message: IValidatorMessage, blockInput: boolean, i18n: I18nModel): Custom {
  return new Custom(method, message, blockInput, i18n);
}
